import request from "@/utils/request.js"

// 获取赛事报名详情
export const listClubCompetitionParticipant = (pageData, id) => {
    return request.get(`/competition/order/admin/participant/${pageData.page}/${pageData.pageSize}/${id}`)
}

// 获取赛事配套服务订单详情
export const listClubCompetitionOrderInfo = (pageData, id, paymentStartTime, paymentEndTime) => {
    return request.get(`/competition/order/admin/supplementaryService/${pageData.page}/${pageData.pageSize}/${id}?paymentStartTime=${paymentStartTime}&paymentEndTime=${paymentEndTime}`)
}

// 俱乐部赛事-周边订单信息列表
export const listMerchandiseOrder = (pageData, competitionGoodsId, formData) => {
    return request.get(`/competition/order/admin/merchandise/${pageData.page}/${pageData.pageSize}/${competitionGoodsId}`, {params: formData})
}